import { render, staticRenderFns } from "./Page502.vue?vue&type=template&id=29a3a570&scoped=true&"
var script = {}
import style0 from "./Page502.vue?vue&type=style&index=0&id=29a3a570&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "29a3a570",
  null
  
)

export default component.exports